var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icon',{staticClass:"spinner",style:({ 'font-size': _vm.size }),attrs:{"icon":['fal', 'spinner-third']}})
}
var staticRenderFns = []

export { render, staticRenderFns }